import React from 'react'
import SIZE from '../../global/Size'
import COLOR from '../../global/Color'
import styled from 'styled-components'

const ContentTitle = ({children}) => {
  return (
    <TextContainer>
      {children}
    </TextContainer>
  );
}

const TextContainer = styled.div`
  font-size: ${props => props.theme.SIZE.X1LARGE};
  font-weight: 600;
  color: ${props => props.theme.COLOR.WHITE};
  position: relative;
  left: 13.5%;

    /* 450px 이상 800px 미만 */
    @media (min-width: 450px) and (max-width: 799px) {
      font-size: ${props => props.theme.SIZE.X05LARGE};
    }
    
    /* 450px 미만 */
    @media (max-width: 449px) {
      font-size: ${props => props.theme.SIZE.X05LARGE};
    }
`;

export default ContentTitle